import _classCallCheck from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Box, Text, VStack } from '@chakra-ui/react';
import * as Bowser from 'bowser';
import { withTranslation } from 'next-i18next';
import { Component } from 'react';
import { getSentry } from 'src/lib/sentry';
import { APP_RELEASE_VERSION, APP_VERSION, BranchConstants } from '../constants';
import { sentryConfig } from '../constants/sentry';
import { UserDataContext } from '../context/UserDataContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: null,
      errorInfo: null,
      hasError: false
    });

    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      console.log({
        error: error,
        errorInfo: errorInfo
      });
      var Sentry = getSentry();

      if (BranchConstants.SITE_WISE_ENABLE_SENTRY && sentryConfig.enableSentry && Sentry !== undefined) {
        var _Sentry$captureExcept;

        Sentry === null || Sentry === void 0 ? void 0 : (_Sentry$captureExcept = Sentry.captureException) === null || _Sentry$captureExcept === void 0 ? void 0 : _Sentry$captureExcept.call(Sentry, error);
      }

      this.setState({
        hasError: true,
        error: error,
        errorInfo: errorInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          hasError = _this$state.hasError,
          errorInfo = _this$state.errorInfo,
          error = _this$state.error;
      var t = this.props.t;
      var browserInfo = Bowser.parse(window.navigator.userAgent);

      if (hasError) {
        // fallback UI
        return /*#__PURE__*/_jsx(UserDataContext.Consumer, {
          children: function children(_ref) {
            var _browserInfo$browser, _window, _window$location;

            var role = _ref.role,
                name = _ref.name,
                profile = _ref.profile;
            return /*#__PURE__*/_jsx(Box, {
              w: "full",
              p: 4,
              e2eid: "components_ErrorBoundary_Box",
              children: /*#__PURE__*/_jsxs(VStack, {
                align: "center",
                justify: "center",
                e2eid: "components_ErrorBoundary_VStack",
                children: [/*#__PURE__*/_jsx(Text, {
                  fontSize: 20,
                  e2eid: "components_ErrorBoundary_Text",
                  children: t('common:error.unknownErrorNoticeEngineer', '發生不預期的錯誤，請將以下錯誤資訊轉交工程部')
                }), /*#__PURE__*/_jsxs(Box, {
                  maxWidth: 800,
                  overflow: "auto",
                  whiteSpace: "pre-wrap",
                  e2eid: "components_ErrorBoundary_Box",
                  children: [/*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text",
                    children: [t('common:error.dateAndTime', '日期時間'), "\uFF1A", new Date().toLocaleString()]
                  }), /*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text_5",
                    children: [t('common:error.versionInfo', '版號資訊'), "\uFF1A", APP_RELEASE_VERSION]
                  }), /*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text_6",
                    children: [t('common:error.internalVersionInfo', '內部版號資訊'), "\uFF1A", APP_VERSION]
                  }), /*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text_7",
                    children: [t('common:error.browerVersionInfo', '瀏覽器資訊'), "\uFF1A", browserInfo.browser.name, ' ', browserInfo === null || browserInfo === void 0 ? void 0 : (_browserInfo$browser = browserInfo.browser) === null || _browserInfo$browser === void 0 ? void 0 : _browserInfo$browser.version]
                  }), /*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text_8",
                    children: [t('common:error.osVersionInfo', '作業系統資訊'), "\uFF1A", browserInfo.os.name, " ", browserInfo.os.version]
                  }), /*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text_9",
                    children: [t('common:error.platformVersionInfo', '使用者平台資訊'), "\uFF1A", browserInfo.platform.type, ' ', browserInfo.platform.vendor]
                  }), /*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text_10",
                    children: [t('common:error.visitedPage', '造訪頁面'), "\uFF1A", (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.toString()]
                  }), /*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text_11",
                    children: [t('common:error.user', '使用者'), "\uFF1A", name, " (", profile === null || profile === void 0 ? void 0 : profile.email, ")"]
                  }), /*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text_12",
                    children: [t('common:error.role', '角色'), "\uFF1A", role.join(',')]
                  }), /*#__PURE__*/_jsxs(Text, {
                    e2eid: "components_ErrorBoundary_Text_13",
                    children: [t('common:error.errorInfo', '錯誤資訊'), "\uFF1A", error === null || error === void 0 ? void 0 : error.toString()]
                  }), /*#__PURE__*/_jsx("br", {
                    e2eid: "components_ErrorBoundary_br"
                  }), errorInfo && /*#__PURE__*/_jsxs(Text, {
                    fontFamily: "\"Lucida Console\", Courier, monospace",
                    e2eid: "components_ErrorBoundary_Text",
                    children: ["Stack: ", errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack]
                  })]
                })]
              })
            });
          }
        });
      } // Return children components in case of no error


      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(Component);

export default withTranslation(['common'])(ErrorBoundary);